import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/globals.css';
import { initializeManifest } from '@lib/pwa-manifest';

// Initialize PWA manifest
initializeManifest();

// Initialize error monitoring in production
if (import.meta.env.PROD) {
  // Sentry for technical error tracking (crashes, bugs)
  import('./lib/sentry').then(({ initSentry }) => {
    initSentry();
  });

  // Web Vitals monitoring - only report performance issues to Sentry
  import('./core/utils/performance.utils').then(({ initWebVitals }) => {
    initWebVitals((metric) => {
      // Log all metrics in dev
      if (import.meta.env.DEV) {
        console.log(`[Web Vitals] ${metric.name}:`, metric.value);
      }

      // Only report poor performance to Sentry
      import('./lib/sentry').then(({ captureSentryMessage }) => {
        // Report if metrics are bad (affects user experience)
        const thresholds: Record<string, number> = {
          LCP: 2500, // Large Contentful Paint > 2.5s is poor
          FID: 100,  // First Input Delay > 100ms is poor
          CLS: 0.25, // Cumulative Layout Shift > 0.25 is poor
          TTFB: 800, // Time to First Byte > 800ms is poor
          FCP: 1800, // First Contentful Paint > 1.8s is poor
          INP: 200,  // Interaction to Next Paint > 200ms is poor
        };

        const threshold = thresholds[metric.name];
        if (threshold && metric.value > threshold) {
          captureSentryMessage(
            `Poor ${metric.name}: ${metric.value.toFixed(0)}${metric.name === 'CLS' ? '' : 'ms'}`,
            'warning'
          );
        }
      });
    });
  });
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found. Check your index.html file.');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);

